"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class OrgPartner extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'orgPartner';
        this._orgName = initParams.org_name;
        this._orgToName = initParams.org_to_name;
        this._name = initParams.name;
        this._orgFromName = initParams.org_from_name;
        this._orgId = initParams.org_id;
        this._orgToId = initParams.org_to_id;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._deviceList = (0, util_1.camelArray)(initParams.device_list);
        this._orgFromId = initParams.org_from_id;
        this._permType = initParams.perm_type;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._sites = (0, util_1.camelArray)(initParams.sites);
        this._partnerDirection = initParams.partner_direction;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._logoImage = initParams.logo_image;
        this._orgFromLogoImage = initParams.org_from_logo_image;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImage = initParams.square_logo_image;
        this._orgFromSquareLogoImage = initParams.org_from_square_logo_image;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
        this._orgFromWhiteLabel = initParams.org_from_white_label;
        this._orgFromInheritWhiteLabelFrom = initParams.org_from_inherit_white_label_from;
        this._orgFromWhiteLabelTheme = initParams.org_from_white_label_theme;
        this._orgFromWhiteLabelCustomTheme = initParams.org_from_white_label_custom_theme;
        this._orgFromContactEmail = initParams.org_from_contact_email;
        this._contactEmail = initParams.contact_email;
        this._issues = initParams.issues;
        this._appliances = initParams.appliances;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
        this._widgetBoardId = initParams.widget_board_id;
    }
    set orgName(value) {
        console.error('Do not set objects this way');
    }
    setOrgName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_name: value }, this);
    }
    get orgName() {
        return this._orgName;
    }
    set orgToName(value) {
        console.error('Do not set objects this way');
    }
    setOrgToName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_to_name: value }, this);
    }
    get orgToName() {
        return this._orgToName;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateOrgPartner(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set orgFromName(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromName(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_name: value }, this);
    }
    get orgFromName() {
        return this._orgFromName;
    }
    set orgId(value) {
        console.error('Do not set objects this way');
    }
    setOrgId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_id: value }, this);
    }
    get orgId() {
        return this._orgId;
    }
    set orgToId(value) {
        console.error('Do not set objects this way');
    }
    setOrgToId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_to_id: value }, this);
    }
    get orgToId() {
        return this._orgToId;
    }
    set dataTypes(value) {
        console.error('Do not set objects this way');
    }
    setDataTypes(value) {
        return this.dataService.updateOrgPartner(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
    }
    get dataTypes() {
        return this._dataTypes;
    }
    set deviceList(value) {
        console.error('Do not set objects this way');
    }
    setDeviceList(value) {
        return this.dataService.updateOrgPartner(this.id, { device_list: (0, util_1.snakeArray)(value) }, this);
    }
    get deviceList() {
        return this._deviceList;
    }
    set orgFromId(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromId(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_id: value }, this);
    }
    get orgFromId() {
        return this._orgFromId;
    }
    set permType(value) {
        console.error('Do not set objects this way');
    }
    setPermType(value) {
        return this.dataService.updateOrgPartner(this.id, { perm_type: value }, this);
    }
    get permType() {
        return this._permType;
    }
    set orgEmailAddress(value) {
        console.error('Do not set objects this way');
    }
    setOrgEmailAddress(value) {
        return this.dataService.updateOrgPartner(this.id, { org_email_address: (0, util_1.snakeArray)(value) }, this);
    }
    get orgEmailAddress() {
        return this._orgEmailAddress;
    }
    set sites(value) {
        console.error('Do not set objects this way');
    }
    setSites(value) {
        return this.dataService.updateOrgPartner(this.id, { sites: (0, util_1.snakeArray)(value) }, this);
    }
    get sites() {
        return this._sites;
    }
    set partnerDirection(value) {
        console.error('Do not set objects this way');
    }
    setPartnerDirection(value) {
        return this.dataService.updateOrgPartner(this.id, { partner_direction: value }, this);
    }
    get partnerDirection() {
        return this._partnerDirection;
    }
    set whiteLabel(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabel(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label: value }, this);
    }
    get whiteLabel() {
        return this._whiteLabel;
    }
    set inheritWhiteLabelFrom(value) {
        console.error('Do not set objects this way');
    }
    setInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrgPartner(this.id, { inherit_white_label_from: value }, this);
    }
    get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
    }
    set whiteLabelTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label_theme: value }, this);
    }
    get whiteLabelTheme() {
        return this._whiteLabelTheme;
    }
    set whiteLabelCustomTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { white_label_custom_theme: value }, this);
    }
    get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
    }
    set logoImage(value) {
        console.error('Do not set objects this way');
    }
    setLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { logo_image: value }, this);
    }
    get logoImage() {
        return this._logoImage;
    }
    set orgFromLogoImage(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_logo_image: value }, this);
    }
    get orgFromLogoImage() {
        return this._orgFromLogoImage;
    }
    set logoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setLogoImageThumbnail(value) {
        return this.dataService.updateOrgPartner(this.id, { logo_image_thumbnail: value }, this);
    }
    get logoImageThumbnail() {
        return this._logoImageThumbnail;
    }
    set squareLogoImage(value) {
        console.error('Do not set objects this way');
    }
    setSquareLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { square_logo_image: value }, this);
    }
    get squareLogoImage() {
        return this._squareLogoImage;
    }
    set orgFromSquareLogoImage(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromSquareLogoImage(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_square_logo_image: value }, this);
    }
    get orgFromSquareLogoImage() {
        return this._orgFromSquareLogoImage;
    }
    set squareLogoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setSquareLogoImageThumbnail(value) {
        return this.dataService.updateOrgPartner(this.id, { square_logo_image_thumbnail: value }, this);
    }
    get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
    }
    set orgFromWhiteLabel(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromWhiteLabel(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label: value }, this);
    }
    get orgFromWhiteLabel() {
        return this._orgFromWhiteLabel;
    }
    set orgFromInheritWhiteLabelFrom(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_inherit_white_label_from: value }, this);
    }
    get orgFromInheritWhiteLabelFrom() {
        return this._orgFromInheritWhiteLabelFrom;
    }
    set orgFromWhiteLabelTheme(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromWhiteLabelTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label_theme: value }, this);
    }
    get orgFromWhiteLabelTheme() {
        return this._orgFromWhiteLabelTheme;
    }
    set orgFromWhiteLabelCustomTheme(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_white_label_custom_theme: value }, this);
    }
    get orgFromWhiteLabelCustomTheme() {
        return this._orgFromWhiteLabelCustomTheme;
    }
    set orgFromContactEmail(value) {
        console.error('Do not set objects this way');
    }
    setOrgFromContactEmail(value) {
        return this.dataService.updateOrgPartner(this.id, { org_from_contact_email: value }, this);
    }
    get orgFromContactEmail() {
        return this._orgFromContactEmail;
    }
    set contactEmail(value) {
        console.error('Do not set objects this way');
    }
    setContactEmail(value) {
        return this.dataService.updateOrgPartner(this.id, { contact_email: value }, this);
    }
    get contactEmail() {
        return this._contactEmail;
    }
    set issues(value) {
        console.error('Do not set objects this way');
    }
    setIssues(value) {
        return this.dataService.updateOrgPartner(this.id, { issues: value }, this);
    }
    get issues() {
        return this._issues;
    }
    set appliances(value) {
        console.error('Do not set objects this way');
    }
    setAppliances(value) {
        return this.dataService.updateOrgPartner(this.id, { appliances: value }, this);
    }
    get appliances() {
        return this._appliances;
    }
    set lowBatteryAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowBatteryAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { low_battery_assets: value }, this);
    }
    get lowBatteryAssets() {
        return this._lowBatteryAssets;
    }
    set lowSignalAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowSignalAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { low_signal_assets: value }, this);
    }
    get lowSignalAssets() {
        return this._lowSignalAssets;
    }
    set assetsWithIssues(value) {
        console.error('Do not set objects this way');
    }
    setAssetsWithIssues(value) {
        return this.dataService.updateOrgPartner(this.id, { assets_with_issues: value }, this);
    }
    get assetsWithIssues() {
        return this._assetsWithIssues;
    }
    set faultyAssets(value) {
        console.error('Do not set objects this way');
    }
    setFaultyAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { faulty_assets: value }, this);
    }
    get faultyAssets() {
        return this._faultyAssets;
    }
    set intermittentAssets(value) {
        console.error('Do not set objects this way');
    }
    setIntermittentAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { intermittent_assets: value }, this);
    }
    get intermittentAssets() {
        return this._intermittentAssets;
    }
    set anomalousAssets(value) {
        console.error('Do not set objects this way');
    }
    setAnomalousAssets(value) {
        return this.dataService.updateOrgPartner(this.id, { anomalous_assets: value }, this);
    }
    get anomalousAssets() {
        return this._anomalousAssets;
    }
    set widgetBoardId(value) {
        console.error('Do not set objects this way');
    }
    setWidgetBoardId(value) {
        return this.dataService.updateOrgPartner(this.id, { widget_board_id: value }, this);
    }
    get widgetBoardId() {
        return this._widgetBoardId;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOrgPartner(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteOrgPartner(this.id, this);
    }
}
exports.default = OrgPartner;
//# sourceMappingURL=orgPartner.js.map